import { Pinia, Store } from 'pinia-class-component';
import {ListItem, UserUiClient} from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
    id: 'UserStore',
    name: 'UserStore',
})
export default class UserStore extends Pinia {
    private readonly api = initClient(UserUiClient);

    //data
    private _loadingPromise: Promise<ListItem[]> | null = null;
    private _users: ListItem[] = [];

    //getter
    get loading(): boolean {
        return this._loadingPromise !== null;
    }

    get users(): ListItem[] {
        return this._users;
    }

    get usersById(): Map<string | undefined, ListItem> {
        return new Map(this._users.map(e => [e.id, e]));
    }

    //actions
    clear(): void {
        this._users.splice(0);
    }

    setUsers(surveys: ListItem[]): void {
        this._users.splice(0);
        this._users.push(...surveys);
    }

    rememberUser(user: ListItem): void {
        const index = this._users.findIndex(e => e.id === user.id);
        if (index >= 0) {
            this._users.splice(index, 1, user);
        } else {
            this._users.push(user);
        }
    }

    forgetUser(user: ListItem): void {
        const index = this._users.findIndex(e => e.id === user.id);
        if (index >= 0) {
            this._users.splice(index, 1);
        }
    }

    async reload(force: boolean = false): Promise<void> {
        if (this._loadingPromise) {
            await this._loadingPromise;
            if (!force) {// when force is true, wait for the current operation to complete, then reload
                return;
            }
        }

        try {
            this._loadingPromise = this.api.getAllUsers(null,null,null,null);
            const users = await this._loadingPromise;
            this.setUsers(users);
        } catch (err) {
            this.clear();
        } finally {
            this._loadingPromise = null;
        }
    }

    async loadIfAbsent(): Promise<void> {
        if (this._users.length > 0) {
            return;
        }
        return await this.reload();
    }
}